import { render, staticRenderFns } from "./CarouselImageUpload.vue?vue&type=template&id=5acd63fe&scoped=true"
import script from "./CarouselImageUpload.vue?vue&type=script&lang=js"
export * from "./CarouselImageUpload.vue?vue&type=script&lang=js"
import style0 from "./CarouselImageUpload.vue?vue&type=style&index=0&id=5acd63fe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5acd63fe",
  null
  
)

export default component.exports